import { CALL_API } from '../middleware/ApiMiddleware';

export const CASE_CREATE_REQUEST = 'CASE_CREATE_REQUEST';
export const CASE_CREATE_SUCCESS = 'CASE_CREATE_SUCCESS';
export const CASE_CREATE_FAILURE = 'CASE_CREATE_FAILURE';

export const FLAG_HISTORY_FETCH_REQUEST = 'FLAG_HISTORY_FETCH_REQUEST';
export const FLAG_HISTORY_FETCH_SUCCESS = 'FLAG_HISTORY_FETCH_SUCCESS';
export const FLAG_HISTORY_FETCH_FAILURE = 'FLAG_HISTORY_FETCH_FAILURE';

export const CASE_FETCH_REQUEST = 'CASE_FETCH_REQUEST';
export const CASE_FETCH_SUCCESS = 'CASE_FETCH_SUCCESS';
export const CASE_FETCH_FAILURE = 'CASE_FETCH_FAILURE';
export const CASE_LIST_CLEAR = 'CASE_LIST_CLEAR';
export const CASE_EDIT_REQUEST = 'CASE_EDIT_REQUEST';
export const CASE_EDIT_SUCCESS = 'CASE_EDIT_SUCCESS';
export const CASE_EDIT_FAILURE = 'CASE_EDIT_FAILURE';

export const CASE_LOCATION_EDIT_REQUEST = 'CASE_LOCATION_EDIT_REQUEST';
export const CASE_LOCATION_EDIT_SUCCESS = 'CASE_LOCATION_EDIT_SUCCESS';
export const CASE_LOCATION_EDIT_FAILURE = 'CASE_LOCATION_EDIT_FAILURE';

export const VIOLATION_ADD_REQUEST = 'VIOLATION_ADD_REQUEST';
export const VIOLATION_ADD_SUCCESS = 'VIOLATION_ADD_SUCCESS';
export const VIOLATION_ADD_FAILURE = 'VIOLATION_ADD_FAILURE';

export const PERFORM_INSPECTION_REQUEST = 'PERFORM_INSPECTION_REQUEST';
export const PERFORM_INSPECTION_SUCCESS = 'PERFORM_INSPECTION_SUCCESS';
export const PERFORM_INSPECTION_FAILURE = 'PERFORM_INSPECTION_FAILURE';

export const DELETE_AND_REISSUE_NOTICE_REQUEST = 'DELETE_AND_REISSUE_NOTICE_REQUEST';
export const DELETE_AND_REISSUE_NOTICE_SUCCESS = 'DELETE_AND_REISSUE_NOTICE_SUCCESS';
export const DELETE_AND_REISSUE_NOTICE_FAILURE = 'DELETE_AND_REISSUE_NOTICE_FAILURE';

export const DELETE_NOTICE_REQUEST = 'DELETE_NOTICE_REQUEST';
export const DELETE_NOTICE_SUCCESS = 'DELETE_NOTICE_SUCCESS';
export const DELETE_NOTICE_FAILURE = 'DELETE_NOTICE_FAILURE';

export const PRINT_NOTICE_REQUEST = 'PRINT_NOTICE_REQUEST';
export const PRINT_NOTICE_SUCCESS = 'PRINT_NOTICE_SUCCESS';
export const PRINT_NOTICE_FAILURE = 'PRINT_NOTICE_FAILURE';

export const CLOSE_CASE_REQUEST = 'CLOSE_CASE_REQUEST';
export const CLOSE_CASE_SUCCESS = 'CLOSE_CASE_SUCCESS';
export const CLOSE_CASE_FAILURE = 'CLOSE_CASE_FAILURE';

export const ADD_CASE_NOTE_REQUEST = 'ADD_CASE_NOTE_REQUEST';
export const ADD_CASE_NOTE_SUCCESS = 'ADD_CASE_NOTE_SUCCESS';
export const ADD_CASE_NOTE_FAILURE = 'ADD_CASE_NOTE_FAILURE';

export const ADD_SUPERVISOR_NOTE_REQUEST = 'ADD_SUPERVISOR_NOTE_REQUEST';
export const ADD_SUPERVISOR_NOTE_SUCCESS = 'ADD_SUPERVISOR_NOTE_SUCCESS';
export const ADD_SUPERVISOR_NOTE_FAILURE = 'ADD_SUPERVISOR_NOTE_FAILURE';

export const ADD_TIME_LOG_REQUEST = 'ADD_TIME_LOG_REQUEST';
export const ADD_TIME_LOG_SUCCESS = 'ADD_TIME_LOG_SUCCESS';
export const ADD_TIME_LOG_FAILURE = 'ADD_TIME_LOG_FAILURE';

export const ADD_FINE_REQUEST = 'ADD_FINE_REQUEST';
export const ADD_FINE_SUCCESS = 'ADD_FINE_SUCCESS';
export const ADD_FINE_FAILURE = 'ADD_FINE_FAILURE';

export const UPDATE_FINE_BILL_TO_CONTACT_REQUEST = 'UPDATE_FINE_BILL_TO_CONTACT_REQUEST';
export const UPDATE_FINE_BILL_TO_CONTACT_SUCCESS = 'UPDATE_FINE_BILL_TO_CONTACT_SUCCESS';
export const UPDATE_FINE_BILL_TO_CONTACT_FAILURE = 'UPDATE_FINE_BILL_TO_CONTACT_FAILURE';

export const ADD_LATE_FEE_REQUEST = 'ADD_LATE_FEE_REQUEST';
export const ADD_LATE_FEE_SUCCESS = 'ADD_LATE_FEE_SUCCESS';
export const ADD_LATE_FEE_FAILURE = 'ADD_LATE_FEE_FAILURE';

export const ADD_PAYMENT_REQUEST = 'ADD_PAYMENT_REQUEST';
export const ADD_PAYMENT_SUCCESS = 'ADD_PAYMENT_SUCCESS';
export const ADD_PAYMENT_FAILURE = 'ADD_PAYMENT_FAILURE';

export const DELETE_TIME_LOG_REQUEST = 'DELETE_TIME_LOG_REQUEST';
export const DELETE_TIME_LOG_SUCCESS = 'DELETE_TIME_LOG_SUCCESS';
export const DELETE_TIME_LOG_FAILURE = 'DELETE_TIME_LOG_FAILURE';

export const UPDATE_TIME_LOG = 'UPDATE_TIME_LOG';

export const EDIT_CASE_NOTE_REQUEST = 'EDIT_CASE_NOTE_REQUEST';
export const EDIT_CASE_NOTE_SUCCESS = 'EDIT_CASE_NOTE_SUCCESS';
export const EDIT_CASE_NOTE_FAILURE = 'EDIT_CASE_NOTE_FAILURE';

export const INIT_CREATE_CASE = 'INIT_CREATE_CASE';
export const INIT_CASE_DETAILS = 'INIT_CASE_DETAILS';
export const EDIT_CASE_SECTION = 'EDIT_CASE_SECTION';
export const EDIT_VIOLATION_ENTITY = 'EDIT_VIOLATION_ENTITY';

export const LOCATION_UPDATE = 'LOCATION_UPDATE';

export const SET_TOTAL_LOGGED_HOURS = 'SET_TOTAL_LOGGED_HOURS';

export const SET_OUTSTANDING_BALANCE = 'SET_OUTSTANDING_BALANCE';

export const SET_DUE_DATE = 'SET_DUE_DATE';

export const VALIDATE_CASE_CONFIG_REQUEST = 'VALIDATE_CASE_CONFIG_REQUEST';
export const VALIDATE_CASE_CONFIG_SUCCESS = 'VALIDATE_CASE_CONFIG_SUCCESS';
export const VALIDATE_CASE_CONFIG_FAILURE = 'VALIDATE_CASE_CONFIG_FAILURE';

export const VOID_WAIVE_TRANSACTION_REQUEST = 'VOID_WAIVE_TRANSACTION_REQUEST';
export const VOID_WAIVE_TRANSACTION_SUCCESS = 'VOID_WAIVE_TRANSACTION_SUCCESS';
export const VOID_WAIVE_TRANSACTION_FAILURE = 'VOID_WAIVE_TRANSACTION_FAILURE';

export const EDIT_CASE_ASSIGNEES_REQUEST = 'EDIT_CASE_ASSIGNEES_REQUEST';
export const EDIT_CASE_ASSIGNEES_SUCCESS = 'EDIT_CASE_ASSIGNEES_SUCCESS';
export const EDIT_CASE_ASSIGNEES_FAILURE = 'EDIT_CASE_ASSIGNEES_FAILURE';

export const EDIT_CASE_INITIATION_TYPE_REQUEST = 'EDIT_CASE_INITIATION_TYPE_REQUEST';
export const EDIT_CASE_INITIATION_TYPE_SUCCESS = 'EDIT_CASE_INITIATION_TYPE_SUCCESS';
export const EDIT_CASE_INITIATION_TYPE_FAILURE = 'EDIT_CASE_INITIATION_TYPE_FAILURE';

export const EDIT_CASE_ENTITY_REQUEST = 'EDIT_CASE_ENTITY_REQUEST';
export const EDIT_CASE_ENTITY_SUCCESS = 'EDIT_CASE_ENTITY_SUCCESS';
export const EDIT_CASE_ENTITY_FAILURE = 'EDIT_CASE_ENTITY_FAILURE';

export const EDIT_CASE_VIOLATION_LOCATION_UNITS_REQUEST = 'EDIT_CASE_VIOLATION_LOCATION_UNITS_REQUEST';
export const EDIT_CASE_VIOLATION_LOCATION_UNITS_SUCCESS = 'EDIT_CASE_VIOLATION_LOCATION_UNITS_SUCCESS';
export const EDIT_CASE_VIOLATION_LOCATION_UNITS_FAILURE = 'EDIT_CASE_VIOLATION_LOCATION_UNITS_FAILURE';

export const ADD_NEW_VIOLATIONS_REQUEST = 'ADD_NEW_VIOLATIONS_REQUEST';
export const ADD_NEW_VIOLATIONS_SUCCESS = 'ADD_NEW_VIOLATIONS_SUCCESS';
export const ADD_NEW_VIOLATIONS_FAILURE = 'ADD_NEW_VIOLATIONS_FAILURE';

export const EDIT_CASE_SECTION_REQUEST = 'EDIT_CASE_SECTION_REQUEST';
export const EDIT_CASE_SECTION_SUCCESS = 'EDIT_CASE_SECTION_SUCCESS';
export const EDIT_CASE_SECTION_FAILURE = 'EDIT_CASE_SECTION_FAILURE';

export const GET_CASE_HISTORY_REQUEST = 'GET_CASE_HISTORY_REQUEST';
export const GET_CASE_HISTORY_SUCCESS = 'GET_CASE_HISTORY_SUCCESS';
export const GET_CASE_HISTORY_FAILURE = 'GET_CASE_HISTORY_FAILURE';

export const GET_TIME_LOG_HISTORY_REQUEST = 'GET_TIME_LOG_HISTORY_REQUEST';
export const GET_TIME_LOG_HISTORY_SUCCESS = 'GET_TIME_LOG_HISTORY_SUCCESS';
export const GET_TIME_LOG_HISTORY_FAILURE = 'GET_TIME_LOG_HISTORY_FAILURE';

export const ADD_ATTACHMENTS_REQUEST = 'ADD_ATTACHMENTS_REQUEST';
export const ADD_ATTACHMENTS_SUCCESS = 'ADD_ATTACHMENTS_SUCCESS';
export const ADD_ATTACHMENTS_FAILURE = 'ADD_ATTACHMENTS_FAILURE';

export const UPDATE_ATTACHMENTS_REQUEST = 'UPDATE_ATTACHMENTS_REQUEST';
export const UPDATE_ATTACHMENTS_SUCCESS = 'UPDATE_ATTACHMENTS_SUCCESS';
export const UPDATE_ATTACHMENTS_FAILURE = 'UPDATE_ATTACHMENTS_FAILURE';

export const GET_CASES_COUNT_BY_LOCATION_REQUEST = 'GET_CASES_COUNT_BY_LOCATION_REQUEST';
export const GET_CASES_COUNT_BY_LOCATION_SUCCESS = 'GET_CASES_COUNT_BY_LOCATION_SUCCESS';
export const GET_CASES_COUNT_BY_DRAFT_LOCATION_SUCCESS = 'GET_CASES_COUNT_BY_DRAFT_LOCATION_SUCCESS';
export const GET_CASES_COUNT_BY_LOCATION_CCP_SUCCESS = 'GET_CASES_COUNT_BY_LOCATION_CCP_SUCCESS';
export const GET_CASES_COUNT_BY_LOCATION_FAILURE = 'GET_CASES_COUNT_BY_LOCATION_FAILURE';

export const DELETE_ATTACHMENT_REQUEST = 'DELETE_ATTACHMENT_REQUEST';
export const DELETE_ATTACHMENT_SUCCESS = 'DELETE_ATTACHMENT_SUCCESS';
export const DELETE_ATTACHMENT_FAILURE = 'DELETE_ATTACHMENT_FAILURE';

export const GET_ATTACHMENT_REQUEST = 'GET_ATTACHMENT_REQUEST';
export const GET_ATTACHMENT_SUCCESS = 'GET_ATTACHMENT_SUCCESS';
export const GET_ATTACHMENT_FAILURE = 'GET_ATTACHMENT_FAILURE';

export const CASE_CONTACT_EDIT_REQUEST = 'CASE_CONTACT_EDIT_REQUEST';
export const CASE_CONTACT_EDIT_SUCCESS = 'CASE_CONTACT_EDIT_SUCCESS';
export const CASE_CONTACT_EDIT_FAILURE = 'CASE_CONTACT_EDIT_FAILURE';

export const CASE_CONTACT_ADD_REQUEST = 'CASE_CONTACT_ADD_REQUEST';
export const CASE_CONTACT_ADD_SUCCESS = 'CASE_CONTACT_ADD_SUCCESS';
export const CASE_CONTACT_ADD_FAILURE = 'CASE_CONTACT_ADD_FAILURE';

export const EDIT_CASE_CONTACT_LOCATION_UNIT_REQUEST = 'EDIT_CASE_CONTACT_LOCATION_UNIT_REQUEST';
export const EDIT_CASE_CONTACT_LOCATION_UNIT_SUCCESS = 'EDIT_CASE_CONTACT_LOCATION_UNIT_SUCCESS';
export const EDIT_CASE_CONTACT_LOCATION_UNIT_FAILURE = 'EDIT_CASE_CONTACT_LOCATION_UNIT_FAILURE';

export const CASE_CONTACT_DELETE_REQUEST = 'CASE_CONTACT_DELETE_REQUEST';
export const CASE_CONTACT_DELETE_SUCCESS = 'CASE_CONTACT_DELETE_SUCCESS';
export const CASE_CONTACT_DELETE_FAILURE = 'CASE_CONTACT_DELETE_FAILURE';

export const CASE_CONTACT_EDIT = 'CASE_CONTACT_EDIT';

export const CASE_LIST_FETCH_REQUEST = 'CASE_LIST_FETCH_REQUEST';
export const CASE_LIST_FETCH_SUCCESS = 'CASE_LIST_FETCH_SUCCESS';
export const CASE_LIST_FETCH_FAILURE = 'CASE_LIST_FETCH_FAILURE';

export const CASE_LIST_PRINT_FETCH_REQUEST = 'CASE_LIST_PRINT_FETCH_REQUEST';
export const CASE_LIST_PRINT_FETCH_SUCCESS = 'CASE_LIST_PRINT_FETCH_SUCCESS';
export const CASE_LIST_PRINT_FETCH_FAILURE = 'CASE_LIST_PRINT_FETCH_FAILURE';

export const DOWNLOAD_CASE_LIST_CSV_REQUEST = 'DOWNLOAD_CASE_LIST_CSV_REQUEST';
export const DOWNLOAD_CASE_LIST_CSV_SUCCESS = 'DOWNLOAD_CASE_LIST_CSV_SUCCESS';
export const DOWNLOAD_CASE_LIST_CSV_FAILURE = 'DOWNLOAD_CASE_LIST_CSV_FAILURE';

export const GENERATE_NOTICE_REQUEST = 'GENERATE_NOTICE_REQUEST';
export const GENERATE_NOTICE_SUCCESS = 'GENERATE_NOTICE_SUCCESS';
export const GENERATE_NOTICE_FAILURE = 'GENERATE_NOTICE_FAILURE';

export const EDIT_NOTICE_DETAILS_REQUEST = 'EDIT_NOTICE_DETAILS_REQUEST';
export const EDIT_NOTICE_DETAILS_SUCCESS = 'EDIT_NOTICE_DETAILS_SUCCESS';
export const EDIT_NOTICE_DETAILS_FAILURE = 'EDIT_NOTICE_DETAILS_FAILURE';

export const EDIT_SCHEDULED_INSPECTION_REQUEST = 'EDIT_SCHEDULED_INSPECTION_REQUEST';
export const EDIT_SCHEDULED_INSPECTION_SUCCESS = 'EDIT_SCHEDULED_INSPECTION_SUCCESS';
export const EDIT_SCHEDULED_INSPECTION_FAILURE = 'EDIT_SCHEDULED_INSPECTION_FAILURE';

export const SCHEDULE_INSPECTION_REQUEST = 'SCHEDULE_INSPECTION_REQUEST';
export const SCHEDULE_INSPECTION_SUCCESS = 'SCHEDULE_INSPECTION_SUCCESS';
export const SCHEDULE_INSPECTION_FAILURE = 'SCHEDULE_INSPECTION_FAILURE';

export const GET_INSPECTION_DRAFTS_REQUEST = 'GET_INSPECTION_DRAFTS_REQUEST';
export const GET_INSPECTION_DRAFTS_SUCCESS = 'GET_INSPECTION_DRAFTS_SUCCESS';
export const GET_INSPECTION_DRAFTS_FAILURE = 'GET_INSPECTION_DRAFTS_FAILURE';

export const START_INSPECTION_DRAFT_REQUEST = 'START_INSPECTION_DRAFT_REQUEST';
export const START_INSPECTION_DRAFT_SUCCESS = 'START_INSPECTION_DRAFT_SUCCESS';
export const START_INSPECTION_DRAFT_FAILURE = 'START_INSPECTION_DRAFT_FAILURE';

export const GET_INSPECTION_DRAFT_REQUEST = 'GET_INSPECTION_DRAFT_REQUEST';
export const GET_INSPECTION_DRAFT_SUCCESS = 'GET_INSPECTION_DRAFT_SUCCESS';
export const GET_INSPECTION_DRAFT_FAILURE = 'GET_INSPECTION_DRAFT_FAILURE';

export const SAVE_INSPECTION_DRAFT_REQUEST = 'SAVE_INSPECTION_DRAFT_REQUEST';
export const SAVE_INSPECTION_DRAFT_SUCCESS = 'SAVE_INSPECTION_DRAFT_SUCCESS';
export const SAVE_INSPECTION_DRAFT_FAILURE = 'SAVE_INSPECTION_DRAFT_FAILURE';

export const FINALIZE_INSPECTION_DRAFT_REQUEST = 'FINALIZE_INSPECTION_DRAFT_REQUEST';
export const FINALIZE_INSPECTION_DRAFT_SUCCESS = 'FINALIZE_INSPECTION_DRAFT_SUCCESS';
export const FINALIZE_INSPECTION_DRAFT_FAILURE = 'FINALIZE_INSPECTION_DRAFT_FAILURE';

export const GET_ALL_ABATEMENT_STAGES_REQUEST = 'GET_ALL_ABATEMENT_STAGES_REQUEST';
export const GET_ALL_ABATEMENT_STAGES_SUCCESS = 'GET_ALL_ABATEMENT_STAGES_SUCCESS';
export const GET_ALL_ABATEMENT_STAGES_FAILURE = 'GET_ALL_ABATEMENT_STAGES_FAILURE';

export const GET_EXTERNAL_CASE_SOURCES_REQUEST = 'GET_EXTERNAL_CASE_SOURCES_REQUEST';
export const GET_EXTERNAL_CASE_SOURCES_SUCCESS = 'GET_EXTERNAL_CASE_SOURCES_SUCCESS';
export const GET_EXTERNAL_CASE_SOURCES_FAILURE = 'GET_EXTERNAL_CASE_SOURCES_FAILURE';

export const REOPEN_CASE_REQUEST = 'REOPEN_CASE_REQUEST';
export const REOPEN_CASE_SUCCESS = 'REOPEN_CASE_SUCCESS';
export const REOPEN_CASE_FAILURE = 'REOPEN_CASE_FAILURE';

export const UPDATE_CASE_EMAIL_READ_STATUS_REQUEST = 'UPDATE_CASE_EMAIL_READ_STATUS_REQUEST';
export const UPDATE_CASE_EMAIL_READ_STATUS_SUCCESS = 'UPDATE_CASE_EMAIL_READ_STATUS_SUCCESS';
export const UPDATE_CASE_EMAIL_READ_STATUS_FAILURE = 'UPDATE_CASE_EMAIL_READ_STATUS_FAILURE';

export const CASE_DELETE_REQUEST = 'CASE_DELETE_REQUEST';
export const CASE_DELETE_SUCCESS = 'CASE_DELETE_SUCCESS';
export const CASE_DELETE_FAILURE = 'CASE_DELETE_FAILURE';

export const CLEAR_CASE = 'CLEAR_CASE';
export const SET_CREATE_CASE_ACTION = 'SET_CREATE_CASE_ACTION';

export const EDIT_INSPECTION_NOTE_REQUEST = 'EDIT_INSPECTION_NOTE_REQUEST';
export const EDIT_INSPECTION_NOTE_SUCCESS = 'EDIT_INSPECTION_NOTE_SUCCESS';
export const EDIT_INSPECTION_NOTE_FAILURE = 'EDIT_INSPECTION_NOTE_FAILURE';

export const EDIT_CASE_VIOLATION_DISPOSITION_REQUEST = 'EDIT_CASE_VIOLATION_DISPOSITION_REQUEST';
export const EDIT_CASE_VIOLATION_DISPOSITION_SUCCESS = 'EDIT_CASE_VIOLATION_DISPOSITION_SUCCESS';
export const EDIT_CASE_VIOLATION_DISPOSITION_FAILURE = 'EDIT_CASE_VIOLATION_DISPOSITION_FAILURE';

export const MODIFY_DATES_REQUEST = 'MODIFY_DATES_REQUEST';
export const MODIFY_DATES_SUCCESS = 'MODIFY_DATES_SUCCESS';
export const MODIFY_DATES_FAILURE = 'MODIFY_DATES_FAILURE';

export const INITIATE_FORCED_ABATEMENT_REQUEST = 'INITIATE_FORCED_ABATEMENT_REQUEST';
export const INITIATE_FORCED_ABATEMENT_SUCCESS = 'INITIATE_FORCED_ABATEMENT_SUCCESS';
export const INITIATE_FORCED_ABATEMENT_FAILURE = 'INITIATE_FORCED_ABATEMENT_FAILURE';

export const EDIT_FORCED_ABATEMENT_NOTE_REQUEST = 'EDIT_FORCED_ABATEMENT_NOTE_REQUEST';
export const EDIT_FORCED_ABATEMENT_NOTE_SUCCESS = 'EDIT_FORCED_ABATEMENT_NOTE_SUCCESS';
export const EDIT_FORCED_ABATEMENT_NOTE_FAILURE = 'EDIT_FORCED_ABATEMENT_NOTE_FAILURE';

export const ADD_FORCED_ABATEMENT_ACTIVITY_REQUEST = 'ADD_FORCED_ABATEMENT_ACTIVITY_REQUEST';
export const ADD_FORCED_ABATEMENT_ACTIVITY_SUCCESS = 'ADD_FORCED_ABATEMENT_ACTIVITY_SUCCESS';
export const ADD_FORCED_ABATEMENT_ACTIVITY_FAILURE = 'ADD_FORCED_ABATEMENT_ACTIVITY_FAILURE';

export const EDIT_FORCED_ABATEMENT_ACTIVITY_REQUEST = 'EDIT_FORCED_ABATEMENT_ACTIVITY_REQUEST';
export const EDIT_FORCED_ABATEMENT_ACTIVITY_SUCCESS = 'EDIT_FORCED_ABATEMENT_ACTIVITY_SUCCESS';
export const EDIT_FORCED_ABATEMENT_ACTIVITY_FAILURE = 'EDIT_FORCED_ABATEMENT_ACTIVITY_FAILURE';

export const DELETE_FORCED_ABATEMENT_ACTIVITY_REQUEST = 'DELETE_FORCED_ABATEMENT_ACTIVITY_REQUEST';
export const DELETE_FORCED_ABATEMENT_ACTIVITY_SUCCESS = 'DELETE_FORCED_ABATEMENT_ACTIVITY_SUCCESS';
export const DELETE_FORCED_ABATEMENT_ACTIVITY_FAILURE = 'DELETE_FORCED_ABATEMENT_ACTIVITY_FAILURE';

export const EXIT_DRAFT_MODE = 'EXIT_DRAFT_MODE';
export const ENTER_DRAFT_MODE = 'ENTER_DRAFT_MODE';

export const DISMISS_FORCED_ABATEMENT_TRIGGER_REQUEST = 'DISMISS_FORCED_ABATEMENT_TRIGGER_REQUEST';
export const DISMISS_FORCED_ABATEMENT_TRIGGER_SUCCESS = 'DISMISS_FORCED_ABATEMENT_TRIGGER_SUCCESS';
export const DISMISS_FORCED_ABATEMENT_TRIGGER_FAILURE = 'DISMISS_FORCED_ABATEMENT_TRIGGER_FAILURE';

export const GET_FINE_PAYEMNT_REQUEST = 'GET_FINE_PAYEMNT_REQUEST';
export const GET_FINE_PAYEMNT_SUCCESS = 'GET_FINE_PAYEMNT_SUCCESS';
export const GET_FINE_PAYEMNT_FAILURE = 'GET_FINE_PAYEMNT_FAILURE';

export const GET_SCHEDULED_LATE_FEE_REQUEST = 'GET_SCHEDULED_LATE_FEE_REQUEST';
export const GET_SCHEDULED_LATE_FEE_SUCCESS = 'GET_SCHEDULED_LATE_FEE_SUCCESS';
export const GET_SCHEDULED_LATE_FEE_FAILURE = 'GET_SCHEDULED_LATE_FEE_FAILURE';

export const CREATE_AND_LINK_CASE = 'CREATE_AND_LINK_CASE';

export const DELETE_CASE_LINK_REQUEST = 'DELETE_CASE_LINK_REQUEST';
export const DELETE_CASE_LINK_SUCCESS = 'DELETE_CASE_LINK_SUCCESS';
export const DELETE_CASE_LINK_FAILURE = 'DELETE_CASE_LINK_FAILURE';

export const FETCH_LOCATION_CUSTOM_FIELD_VALUES_REQUEST = 'FETCH_LOCATION_CUSTOM_FIELD_VALUES_REQUEST';
export const FETCH_LOCATION_CUSTOM_FIELD_VALUES_SUCCESS = 'FETCH_LOCATION_CUSTOM_FIELD_VALUES_SUCCESS';
export const FETCH_LOCATION_CUSTOM_FIELD_VALUES_FAILURE = 'FETCH_LOCATION_CUSTOM_FIELD_VALUES_FAILURE';
export const LOAD_MORE_LOCATION_CUSTOM_FIELD_VALUES = 'LOAD_MORE_LOCATION_CUSTOM_FIELD_VALUES';

export const FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_REQUEST =
  'FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_REQUEST';
export const FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_SUCCESS =
  'FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_SUCCESS';
export const FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_FAILURE =
  'FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_FAILURE';

export const GENERATE_DOCUMENT_REQUEST = 'GENERATE_DOCUMENT_REQUEST';
export const GENERATE_DOCUMENT_SUCCESS = 'GENERATE_DOCUMENT_SUCCESS';
export const GENERATE_DOCUMENT_FAILURE = 'GENERATE_DOCUMENT_FAILURE';

export const EDIT_DOCUMENT_REQUEST = 'EDIT_DOCUMENT_REQUEST';
export const EDIT_DOCUMENT_SUCCESS = 'EDIT_DOCUMENT_SUCCESS';
export const EDIT_DOCUMENT_FAILURE = 'EDIT_DOCUMENT_FAILURE';

export const GENERATE_CASE_NOTICE_REQUEST = 'GENERATE_CASE_NOTICE_REQUEST';
export const GENERATE_CASE_NOTICE_SUCCESS = 'GENERATE_CASE_NOTICE_SUCCESS';
export const GENERATE_CASE_NOTICE_FAILURE = 'GENERATE_CASE_NOTICE_FAILURE';

export const ISSUE_CASE_NOTICE_REQUEST = 'ISSUE_CASE_NOTICE_REQUEST';
export const ISSUE_CASE_NOTICE_SUCCESS = 'ISSUE_CASE_NOTICE_SUCCESS';
export const ISSUE_CASE_NOTICE_FAILURE = 'ISSUE_CASE_NOTICE_FAILURE';

export const SEND_XERCE_EMAIL_REQUEST = 'SEND_XERCE_EMAIL_REQUEST';
export const SEND_XERCE_EMAIL_SUCCESS = 'SEND_XERCE_EMAIL_SUCCESS';
export const SEND_XERCE_EMAIL_FAILURE = 'SEND_XERCE_EMAIL_FAILURE';

export const GET_PRIVATE_CE_DATA_REQUEST = 'GET_PRIVATE_CE_DATA_REQUEST';
export const GET_PRIVATE_CE_DATA_SUCCESS = 'GET_PRIVATE_CE_DATA_SUCCESS';
export const GET_PRIVATE_CE_DATA_FAILURE = 'GET_PRIVATE_CE_DATA_FAILUREURE';

export const RESEND_MAGIC_LINK_REQUEST = 'RESEND_MAGIC_LINK_REQUEST';
export const RESEND_MAGIC_LINK_SUCCESS = 'RESEND_MAGIC_LINK_SUCCESS';
export const RESEND_MAGIC_LINK_FAILURE = 'RESEND_MAGIC_LINK_FAILURE';

export const GROUP_ACTION_REQUEST = 'GROUP_ACTION_REQUEST';
export const GROUP_ACTION_SUCCESS = 'GROUP_ACTION_SUCCESS';
export const GROUP_ACTION_FAILURE = 'GROUP_ACTION_FAILURE';

export const STOP_REOCCURING_LATE_FEE_REQUEST = 'STOP_REOCCURING_LATE_FEE_REQUEST';
export const STOP_REOCCURING_LATE_FEE_SUCCESS = 'STOP_REOCCURING_LATE_FEE_SUCCESS';
export const STOP_REOCCURING_LATE_FEE_FAILURE = 'STOP_REOCCURING_LATE_FEE_FAILURE';

export const GENERATE_DRAFT_NOTICE_REQUEST = 'GENERATE_DRAFT_NOTICE_REQUEST';
export const GENERATE_DRAFT_NOTICE_SUCCESS = 'GENERATE_DRAFT_NOTICE_SUCCESS';
export const GENERATE_DRAFT_NOTICE_FAILURE = 'GENERATE_DRAFT_NOTICE_FAILURE';

export const GENERATE_FAA_DOCUMENT_REQUEST = 'GENERATE_FAA_DOCUMENT_REQUEST';
export const GENERATE_FAA_DOCUMENT_SUCCESS = 'GENERATE_FAA_DOCUMENT_SUCCESS';
export const GENERATE_FAA_DOCUMENT_FAILURE = 'GENERATE_FAA_DOCUMENT_FAILURE';

export const DELETE_AND_REISSUE_DRAFT_NOTICE_REQUEST = 'DELETE_AND_REISSUE_DRAFT_NOTICE_REQUEST';
export const DELETE_AND_REISSUE_DRAFT_NOTICE_SUCCESS = 'DELETE_AND_REISSUE_DRAFT_NOTICE_SUCCESS';
export const DELETE_AND_REISSUE_DRAFT_NOTICE_FAILURE = 'DELETE_AND_REISSUE_DRAFT_NOTICE_FAILURE';

export const APPLY_DRAFT_NOTICE_REQUEST = 'APPLY_DRAFT_NOTICE_REQUEST';
export const APPLY_DRAFT_NOTICE_SUCCESS = 'APPLY_DRAFT_NOTICE_SUCCESS';
export const APPLY_DRAFT_NOTICE_FAILURE = 'APPLY_DRAFT_NOTICE_FAILURE';

export const PRINT_QUEUE_NOTICE_REQUEST = 'PRINT_QUEUE_NOTICE_REQUEST';
export const PRINT_QUEUE_NOTICE_SUCCESS = 'PRINT_QUEUE_NOTICE_SUCCESS';
export const PRINT_QUEUE_NOTICE_FAILURE = 'PRINT_QUEUE_NOTICE_FAILURE';

export const UPDATE_CASE_COLLECTION_STATUS_REQUEST = 'UPDATE_CASE_COLLECTION_STATUS_REQUEST';
export const UPDATE_CASE_COLLECTION_STATUS_SUCCESS = 'UPDATE_CASE_COLLECTION_STATUS_SUCCESS';
export const UPDATE_CASE_COLLECTION_STATUS_FAILURE = 'UPDATE_CASE_COLLECTION_STATUS_FAILURE';

export const FETCH_CASE_COLLECTION_STATUS_REQUEST = 'FETCH_CASE_COLLECTION_STATUS_REQUEST';
export const FETCH_CASE_COLLECTION_STATUS_SUCCESS = 'FETCH_CASE_COLLECTION_STATUS_SUCCESS';
export const FETCH_CASE_COLLECTION_STATUS_FAILURE = 'FETCH_CASE_COLLECTION_STATUS_FAILURE';

export const GET_NOTICE_RECIPIENTS_REQUEST = 'GET_NOTICE_RECIPIENTS_REQUEST';
export const GET_NOTICE_RECIPIENTS_SUCCESS = 'GET_NOTICE_RECIPIENTS_SUCCESS';
export const GET_NOTICE_RECIPIENTS_FAILURE = 'GET_NOTICE_RECIPIENTS_FAILURE';

export const EDIT_RECIPIENT_CMN_REQUEST = 'EDIT_RECIPIENT_CMN_REQUEST';
export const EDIT_RECIPIENT_CMN_SUCCESS = 'EDIT_RECIPIENT_CMN_SUCCESS';
export const EDIT_RECIPIENT_CMN_FAILURE = 'EDIT_RECIPIENT_CMN_FAILURE';

export const EDIT_FAA_FIELD_REQUEST = 'EDIT_FAA_FIELD_REQUEST';
export const EDIT_FAA_FIELD_SUCCESS = 'EDIT_FAA_FIELD_SUCCESS';
export const EDIT_FAA_FIELD_FAILURE = 'EDIT_FAA_FIELD_FAILURE';

const xerceCasesBaseURL = 'xerce/cases';
const xerceUnlinkCaseBaseURL = 'xerce/unlink-issue';
const agenciesXerceBaseURL = 'agencies/xerce';
const getInspectionDraftsBaseURL = (caseId: number, scheduledInspectionId: number) =>
  `${xerceCasesBaseURL}/${caseId}/inspections/${scheduledInspectionId}/drafts`;

export const createCase = (caseRequest: IXerceCaseRequest) => ({
  [CALL_API]: {
    endpoint: xerceCasesBaseURL,
    method: 'post',
    body: caseRequest,
    authenticated: true,
    types: [CASE_CREATE_REQUEST, CASE_CREATE_SUCCESS, CASE_CREATE_FAILURE],
  },
});

export const performInspection = (
  caseId: number,
  inspectionId: number,
  performInspectionRequest: IPerformInspectionRequest
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/perform-inspections/${inspectionId}`,
    method: 'post',
    authenticated: true,
    body: performInspectionRequest,
    types: [PERFORM_INSPECTION_REQUEST, PERFORM_INSPECTION_SUCCESS, PERFORM_INSPECTION_FAILURE],
  },
});

export const deleteAndReissueNotice = (
  caseId: number,
  inspectionId: number,
  deleteAndReissueNoticeRequest: IDeleteAndReissueNoticeRequest
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/delete-reissue-notice/${inspectionId}`, // tslint:disable-line
    method: 'post',
    authenticated: true,
    body: deleteAndReissueNoticeRequest,
    types: [DELETE_AND_REISSUE_NOTICE_REQUEST, DELETE_AND_REISSUE_NOTICE_SUCCESS, DELETE_AND_REISSUE_NOTICE_FAILURE],
  },
});

export const deleteNotice = (caseId: number, inspectionId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/delete-notice/${inspectionId}`, // tslint:disable-line
    method: 'delete',
    authenticated: true,
    body: {},
    types: [DELETE_NOTICE_REQUEST, DELETE_NOTICE_SUCCESS, DELETE_NOTICE_FAILURE],
  },
});

export const updatePrintNoticeHistory = (caseId: number, printNoticeRequest: IPrintNoticeOrDocumentRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/print-notice-history`,
    method: 'post',
    authenticated: true,
    body: printNoticeRequest,
    types: [PRINT_NOTICE_REQUEST, PRINT_NOTICE_SUCCESS, PRINT_NOTICE_FAILURE],
  },
});

export const deleteAndReissueDraftNotice = (
  caseId: number,
  inspectionId: number,
  deleteAndReissueNoticeRequest: IDeleteAndReissueNoticeRequest
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/delete-reissue-draft-notice/${inspectionId}`, // tslint:disable-line
    method: 'post',
    authenticated: true,
    body: deleteAndReissueNoticeRequest,
    types: [
      DELETE_AND_REISSUE_DRAFT_NOTICE_REQUEST,
      DELETE_AND_REISSUE_DRAFT_NOTICE_SUCCESS,
      DELETE_AND_REISSUE_DRAFT_NOTICE_FAILURE,
    ],
  },
});

export const generateDraftNotice = (caseId: number, generateDraftNoticeRequest: IGenerateDraftNoticeRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/save-draft-notice`,
    method: 'POST',
    authenticated: true,
    body: generateDraftNoticeRequest,
    types: [GENERATE_DRAFT_NOTICE_REQUEST, GENERATE_DRAFT_NOTICE_SUCCESS, GENERATE_DRAFT_NOTICE_FAILURE],
  },
});

export const applyDraftNotice = (
  caseId: number,
  noticeId: number,
  scheduleInspectionRequest?: IScheduleInspectionRequestObj,
  isQueued?: boolean,
  locationUnitIds?: number[]
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/apply-draft-notice`,
    method: 'POST',
    authenticated: true,
    body: {
      noticeId,
      scheduledInspection: scheduleInspectionRequest,
      isQueued,
      ...(locationUnitIds && { locationUnitIds }),
    },
    types: [APPLY_DRAFT_NOTICE_REQUEST, APPLY_DRAFT_NOTICE_SUCCESS, APPLY_DRAFT_NOTICE_FAILURE],
  },
});

export const addNoticeToPrintQueue = (caseId: number, noticeId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/print-queue-notice`,
    method: 'POST',
    authenticated: true,
    body: {
      noticeId,
    },
    types: [PRINT_QUEUE_NOTICE_REQUEST, PRINT_QUEUE_NOTICE_SUCCESS, PRINT_QUEUE_NOTICE_FAILURE],
  },
});

export const closeCase = (caseId: number, closeCaseRequest: ICloseCaseRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/close-case`,
    method: 'post',
    authenticated: true,
    body: closeCaseRequest,
    types: [CLOSE_CASE_REQUEST, CLOSE_CASE_SUCCESS, CLOSE_CASE_FAILURE],
  },
});

export const updateLocation = (caseLocation: IXerceCaseLocationRequest) => ({
  type: LOCATION_UPDATE,
  payload: caseLocation,
});

// Case details

export const getCase = (caseId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}`,
    method: 'get',
    authenticated: true,
    types: [CASE_FETCH_REQUEST, CASE_FETCH_SUCCESS, CASE_FETCH_FAILURE],
  },
});

export const getCaseList = (requestBody?: ICaseListRequest, hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/listing`,
    method: 'post',
    body: requestBody,
    authenticated: true,
    types: [CASE_LIST_FETCH_REQUEST, CASE_LIST_FETCH_SUCCESS, CASE_LIST_FETCH_FAILURE],
    hideLoadingWidget: true,
  },
});

export const getCaseListForPrint = (params?: ICaseListRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/listing`,
    method: 'post',
    body: params,
    authenticated: true,
    types: [CASE_LIST_PRINT_FETCH_REQUEST, CASE_LIST_PRINT_FETCH_SUCCESS, CASE_LIST_PRINT_FETCH_FAILURE],
    hideLoadingWidget: true,
  },
});

export const downloadCaseListCSV = (params?: ICaseListRequest, sendEmail?: boolean) => {
  const queryParams: any = {};
  if (sendEmail) {
    queryParams.sendEmail = sendEmail;
  }

  return {
    [CALL_API]: {
      endpoint: `${xerceCasesBaseURL}/summary/download`,
      method: 'post',
      params: queryParams,
      body: params,
      authenticated: true,
      types: [DOWNLOAD_CASE_LIST_CSV_REQUEST, DOWNLOAD_CASE_LIST_CSV_SUCCESS, DOWNLOAD_CASE_LIST_CSV_FAILURE],
    },
  };
};

export const editCaseAssignee = (caseId: number, assigneeId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/assignees`,
    method: 'put',
    body: { assigneeId },
    authenticated: true,
    types: [EDIT_CASE_ASSIGNEES_REQUEST, EDIT_CASE_ASSIGNEES_SUCCESS, EDIT_CASE_ASSIGNEES_FAILURE],
  },
});

export const editCaseInitiationType = (caseId: number, initiationType: string) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/initiation-type`,
    method: 'put',
    body: { initiationType },
    authenticated: true,
    types: [EDIT_CASE_INITIATION_TYPE_REQUEST, EDIT_CASE_INITIATION_TYPE_SUCCESS, EDIT_CASE_INITIATION_TYPE_FAILURE],
  },
});

export const editCaseEntity = (caseId: number, caseViolationId: number, entity: any) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/violations/${caseViolationId}`,
    method: 'put',
    body: { entity },
    authenticated: true,
    types: [EDIT_CASE_ENTITY_REQUEST, EDIT_CASE_ENTITY_SUCCESS, EDIT_CASE_ENTITY_FAILURE],
  },
});

export const editViolationLocationUnits = (caseId: number, caseViolationId: number, locationUnitIds: number[]) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/violations/${caseViolationId}/location-units`,
    method: 'put',
    body: { locationUnitIds },
    authenticated: true,
    types: [
      EDIT_CASE_VIOLATION_LOCATION_UNITS_REQUEST,
      EDIT_CASE_VIOLATION_LOCATION_UNITS_SUCCESS,
      EDIT_CASE_VIOLATION_LOCATION_UNITS_FAILURE,
    ],
  },
});

export const editContactLocationUnit = (caseId: number, caseContactId: number, locationUnitId: number | null) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/contacts/${caseContactId}/location-unit`,
    method: 'put',
    body: { locationUnitId },
    authenticated: true,
    types: [
      EDIT_CASE_CONTACT_LOCATION_UNIT_REQUEST,
      EDIT_CASE_CONTACT_LOCATION_UNIT_SUCCESS,
      EDIT_CASE_CONTACT_LOCATION_UNIT_FAILURE,
    ],
  },
});

export const addNewViolations = (
  caseId: number,
  violations: Array<IXerceCaseViolationResponse | INewCaseViolationRequest>
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/violations`,
    method: 'post',
    body: { violations },
    authenticated: true,
    types: [ADD_NEW_VIOLATIONS_REQUEST, ADD_NEW_VIOLATIONS_SUCCESS, ADD_NEW_VIOLATIONS_FAILURE],
  },
});

export const editViolationDisposition = (caseId: number, caseViolationId: number, dispositionId: number) => ({
  [CALL_API]: {
    // tslint:disable-next-line:max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/violations/${caseViolationId}/disposition`,
    method: 'put',
    body: { dispositionId },
    authenticated: true,
    types: [
      EDIT_CASE_VIOLATION_DISPOSITION_REQUEST,
      EDIT_CASE_VIOLATION_DISPOSITION_SUCCESS,
      EDIT_CASE_VIOLATION_DISPOSITION_FAILURE,
    ],
  },
});

export const editCaseLocation = (caseId: number, caseLocationEditRequest: ICaseLocationEditRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/locations`,
    method: 'put',
    body: caseLocationEditRequest,
    authenticated: true,
    types: [CASE_LOCATION_EDIT_REQUEST, CASE_LOCATION_EDIT_SUCCESS, CASE_LOCATION_EDIT_FAILURE],
  },
});

export const getFlagHistory = (location: string) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/locations/flag-history`,
    params: { location },
    method: 'get',
    authenticated: true,
    types: [FLAG_HISTORY_FETCH_REQUEST, FLAG_HISTORY_FETCH_SUCCESS, FLAG_HISTORY_FETCH_FAILURE],
  },
});

export const editCaseCustomSection = (caseId: number, customCaseFieldValues: ICustomCaseTileValues[]) => ({
  [CALL_API]: {
    endpoint: `cases/${caseId}/case-tiles`,
    method: 'put',
    body: { customCaseFieldValues },
    authenticated: true,
    types: [EDIT_CASE_SECTION_REQUEST, EDIT_CASE_SECTION_SUCCESS, EDIT_CASE_SECTION_FAILURE],
  },
});

export const getAttachments = (caseId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/attachments`,
    method: 'get',
    authenticated: true,
    types: [GET_ATTACHMENT_REQUEST, GET_ATTACHMENT_SUCCESS, GET_ATTACHMENT_FAILURE],
  },
});

export const addAttachments = (caseId: number, attachments: IXerceCaseAttachmentRequest[]) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/attachments`,
    method: 'post',
    authenticated: true,
    body: { attachments },
    types: [ADD_ATTACHMENTS_REQUEST, ADD_ATTACHMENTS_SUCCESS, ADD_ATTACHMENTS_FAILURE],
  },
});

export const updateAttachments = (caseId: number, attachments: IXerceCaseUpdateAttachmentRequest[]) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/attachments`,
    method: 'put',
    authenticated: true,
    body: { attachments },
    types: [UPDATE_ATTACHMENTS_REQUEST, UPDATE_ATTACHMENTS_SUCCESS, UPDATE_ATTACHMENTS_FAILURE],
  },
});

export const editContactPrimaryInfo = (caseId: number, caseContactId: number, requestBody: IContactPrimaryInfo) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/contacts/${caseContactId}`,
    method: 'put',
    body: requestBody,
    authenticated: true,
    types: [CASE_CONTACT_EDIT_REQUEST, CASE_CONTACT_EDIT_SUCCESS, CASE_CONTACT_EDIT_FAILURE],
  },
});

export const addContactToCase = (caseId: number, contactRequest: IXerceCaseContactRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/contacts`,
    method: 'post',
    body: contactRequest,
    authenticated: true,
    types: [CASE_CONTACT_ADD_REQUEST, CASE_CONTACT_ADD_SUCCESS, CASE_CONTACT_ADD_FAILURE],
  },
});

export const deleteContactFromCase = (caseId: number, contactId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/contacts/${contactId}`,
    method: 'delete',
    authenticated: true,
    types: [CASE_CONTACT_DELETE_REQUEST, CASE_CONTACT_DELETE_SUCCESS, CASE_CONTACT_DELETE_FAILURE],
  },
});

export const deleteAttachments = (caseId: number, attachmentIds: number[]) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/attachments`,
    method: 'delete',
    body: { attachmentIds },
    authenticated: true,
    types: [DELETE_ATTACHMENT_REQUEST, DELETE_ATTACHMENT_SUCCESS, DELETE_ATTACHMENT_FAILURE],
  },
});

export const editCaseContact = (contactId: number, contact: IXerceCaseContactResponse) => ({
  type: CASE_CONTACT_EDIT,
  payload: contact,
  contactId,
});

export const updateTimeLog = (timeTrackingId: number) => ({
  type: UPDATE_TIME_LOG,
  timeTrackingId,
});

export const clearCase = () => ({
  type: CLEAR_CASE,
});

export const clearCaseList = () => ({
  type: CASE_LIST_CLEAR,
});

export const generateNotice = (caseId: number, generateNoticeRequest: IGenerateNoticeRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/generate-notice`,
    method: 'POST',
    authenticated: true,
    body: generateNoticeRequest,
    types: [GENERATE_NOTICE_REQUEST, GENERATE_NOTICE_SUCCESS, GENERATE_NOTICE_FAILURE],
  },
});

export const editNoticeDetails = (
  caseId: number,
  inspectionId: number,
  noticeId: number,
  certifiedMailNumber: string,
  noticeContent: string[],
  isCertifiedMailNumberModified: boolean
) => ({
  [CALL_API]: {
    // tslint:disable-next-line:max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/inspection/${inspectionId}/notice/${noticeId}`,
    method: 'PUT',
    authenticated: true,
    body: { certifiedMailNumber, noticeContent, isCertifiedMailNumberModified },
    types: [EDIT_NOTICE_DETAILS_REQUEST, EDIT_NOTICE_DETAILS_SUCCESS, EDIT_NOTICE_DETAILS_FAILURE],
  },
});

export const addCaseNote = (caseId: number, noteContent: string) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/notes`,
    method: 'post',
    authenticated: true,
    body: { noteContent },
    types: [ADD_CASE_NOTE_REQUEST, ADD_CASE_NOTE_SUCCESS, ADD_CASE_NOTE_FAILURE],
  },
});

export const editCaseNote = (caseId: number, noteContent: string, noteId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/notes/${noteId}`,
    method: 'put',
    authenticated: true,
    body: { noteContent },
    types: [EDIT_CASE_NOTE_REQUEST, EDIT_CASE_NOTE_SUCCESS, EDIT_CASE_NOTE_FAILURE],
  },
});

export const editScheduledInspection = (
  caseId: number,
  inspectionId: number,
  assigneeId: number,
  plannedDate: Date | string
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/inspections/${inspectionId}`,
    method: 'PUT',
    authenticated: true,
    body: {
      plannedDate,
      assigneeId,
    },
    types: [EDIT_SCHEDULED_INSPECTION_REQUEST, EDIT_SCHEDULED_INSPECTION_SUCCESS, EDIT_SCHEDULED_INSPECTION_FAILURE],
  },
});

export const scheduleInspection = (
  caseId: number,
  assigneeId: number,
  plannedDate: Date | string,
  isVerificationInspection?: boolean
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/inspections`,
    method: 'post',
    authenticated: true,
    body: {
      plannedDate,
      assigneeId,
      isVerificationInspection,
    },
    types: [SCHEDULE_INSPECTION_REQUEST, SCHEDULE_INSPECTION_SUCCESS, SCHEDULE_INSPECTION_FAILURE],
  },
});

export const getInspectionDrafts = (caseId: number, scheduledInspectionId: number) => ({
  [CALL_API]: {
    endpoint: getInspectionDraftsBaseURL(caseId, scheduledInspectionId),
    method: 'get',
    authenticated: true,
    types: [GET_INSPECTION_DRAFTS_REQUEST, GET_INSPECTION_DRAFTS_SUCCESS, GET_INSPECTION_DRAFTS_FAILURE],
  },
});

export const startInspectionDraft = (caseId: number, scheduledInspectionId: number) => ({
  [CALL_API]: {
    endpoint: getInspectionDraftsBaseURL(caseId, scheduledInspectionId),
    method: 'post',
    authenticated: true,
    types: [START_INSPECTION_DRAFT_REQUEST, START_INSPECTION_DRAFT_SUCCESS, START_INSPECTION_DRAFT_FAILURE],
  },
});

export const getInspectionDraft = (caseId: number, scheduledInspectionId: number, draftId: number) => ({
  [CALL_API]: {
    endpoint: `${getInspectionDraftsBaseURL(caseId, scheduledInspectionId)}/${draftId}`,
    method: 'get',
    authenticated: true,
    types: [GET_INSPECTION_DRAFT_REQUEST, GET_INSPECTION_DRAFT_SUCCESS, GET_INSPECTION_DRAFT_FAILURE],
  },
});

export const saveInspectionDraft = (
  caseId: number,
  scheduledInspectionId: number,
  draftId: number,
  request: ISaveXerceCaseInspectionDraftRequest
) => ({
  [CALL_API]: {
    endpoint: `${getInspectionDraftsBaseURL(caseId, scheduledInspectionId)}/${draftId}`,
    method: 'put',
    body: request,
    authenticated: true,
    hideDefaultAlert: true,
    types: [SAVE_INSPECTION_DRAFT_REQUEST, SAVE_INSPECTION_DRAFT_SUCCESS, SAVE_INSPECTION_DRAFT_FAILURE],
  },
});

export const finalizeInspectionDraft = (caseId: number, scheduledInspectionId: number, draftId: number) => ({
  [CALL_API]: {
    endpoint: `${getInspectionDraftsBaseURL(caseId, scheduledInspectionId)}/${draftId}/finalize`,
    method: 'post',
    authenticated: true,
    hideDefaultAlert: true,
    types: [FINALIZE_INSPECTION_DRAFT_REQUEST, FINALIZE_INSPECTION_DRAFT_SUCCESS, FINALIZE_INSPECTION_DRAFT_FAILURE],
  },
});

export const fetchAbatementStages = (hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/abatement-stages`,
    method: 'get',
    authenticated: true,
    types: [GET_ALL_ABATEMENT_STAGES_REQUEST, GET_ALL_ABATEMENT_STAGES_SUCCESS, GET_ALL_ABATEMENT_STAGES_FAILURE],
    hideLoadingWidget,
  },
});

export const fetchExternalCaseSources = (hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/external-sources`,
    method: 'get',
    authenticated: true,
    types: [GET_EXTERNAL_CASE_SOURCES_REQUEST, GET_EXTERNAL_CASE_SOURCES_SUCCESS, GET_EXTERNAL_CASE_SOURCES_FAILURE],
    hideLoadingWidget,
  },
});

export const reopenCase = (caseId: number, reopenCaseRequest: IReopenCaseRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/reopen`,
    method: 'PUT',
    authenticated: true,
    body: reopenCaseRequest,
    types: [REOPEN_CASE_REQUEST, REOPEN_CASE_SUCCESS, REOPEN_CASE_FAILURE],
  },
});

export const deleteCase = (caseId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}`,
    method: 'delete',
    authenticated: true,
    types: [CASE_DELETE_REQUEST, CASE_DELETE_SUCCESS, CASE_DELETE_FAILURE],
  },
});

export const setCreateCaseAction = (createCaseAction: CreateCaseAction) => ({
  type: SET_CREATE_CASE_ACTION,
  payload: createCaseAction,
});

export const editInspectionNote = (caseId: number, inspectionId: number, noteContent: string) => ({
  [CALL_API]: {
    // tslint:disable-next-line: max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/inspections/${inspectionId}/notes`,
    method: 'PUT',
    authenticated: true,
    body: { noteContent },
    types: [EDIT_INSPECTION_NOTE_REQUEST, EDIT_INSPECTION_NOTE_SUCCESS, EDIT_INSPECTION_NOTE_FAILURE],
  },
});

export const modifyDates = (caseId: number, modifiedDates: IModifiedDatesRequest) => ({
  [CALL_API]: {
    // tslint:disable-next-line: max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/abatement-activities/modify-dates`,
    method: 'PUT',
    authenticated: true,
    body: modifiedDates,
    types: [MODIFY_DATES_REQUEST, MODIFY_DATES_SUCCESS, MODIFY_DATES_FAILURE],
  },
});

export const initiateForcedAbatement = (caseId: number, noteContent: string) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/forced-abatement`,
    method: 'POST',
    body: { noteContent },
    authenticated: true,
    types: [INITIATE_FORCED_ABATEMENT_REQUEST, INITIATE_FORCED_ABATEMENT_SUCCESS, INITIATE_FORCED_ABATEMENT_FAILURE],
  },
});

export const editForcedAbatementNote = (caseId: number, noteId: number, noteContent: string) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/forced-abatement/notes/${noteId}`,
    method: 'PUT',
    body: { noteContent },
    authenticated: true,
    types: [EDIT_FORCED_ABATEMENT_NOTE_REQUEST, EDIT_FORCED_ABATEMENT_NOTE_SUCCESS, EDIT_FORCED_ABATEMENT_NOTE_FAILURE],
  },
});

export const addForcedAbatementActivity = (caseId: number, activityId: number, body: IXerceCaseForcedAbatementReq) => ({
  [CALL_API]: {
    // tslint:disable-next-line:max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/forced-abatement/activities/${activityId}`,
    method: 'POST',
    body,
    authenticated: true,
    types: [
      ADD_FORCED_ABATEMENT_ACTIVITY_REQUEST,
      ADD_FORCED_ABATEMENT_ACTIVITY_SUCCESS,
      ADD_FORCED_ABATEMENT_ACTIVITY_FAILURE,
    ],
  },
});

export const generateFAADocument = (caseId: number, faaDocumentRequest: IGenerateFARequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/generate-faa-document`,
    method: 'POST',
    authenticated: true,
    body: faaDocumentRequest,
    types: [GENERATE_FAA_DOCUMENT_REQUEST, GENERATE_FAA_DOCUMENT_SUCCESS, GENERATE_FAA_DOCUMENT_FAILURE],
  },
});

export const editForcedAbatementActivity = (
  caseId: number,
  activityId: number,
  body: IXerceCaseForcedAbatementReq
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/forced-abatement/activities/${activityId}`,
    method: 'PUT',
    body,
    authenticated: true,
    types: [
      EDIT_FORCED_ABATEMENT_ACTIVITY_REQUEST,
      EDIT_FORCED_ABATEMENT_ACTIVITY_SUCCESS,
      EDIT_FORCED_ABATEMENT_ACTIVITY_FAILURE,
    ],
  },
});

export const deletetForcedAbatementActivity = (caseId: number, activityId: number) => ({
  [CALL_API]: {
    // tslint:disable-next-line:max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/forced-abatement/activities/${activityId}`,
    method: 'DELETE',
    authenticated: true,
    types: [
      DELETE_FORCED_ABATEMENT_ACTIVITY_REQUEST,
      DELETE_FORCED_ABATEMENT_ACTIVITY_SUCCESS,
      DELETE_FORCED_ABATEMENT_ACTIVITY_FAILURE,
    ],
  },
});

export const enterDraftMode = () => ({
  type: ENTER_DRAFT_MODE,
});

export const exitDraftMode = () => ({
  type: EXIT_DRAFT_MODE,
});

export const dismissForcedAbatementTrigger = (caseId: number) => ({
  [CALL_API]: {
    // tslint:disable-next-line:max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/forced-abatement/disable-fa-recommendation`,
    method: 'PUT',
    body: null,
    authenticated: true,
    types: [
      DISMISS_FORCED_ABATEMENT_TRIGGER_REQUEST,
      DISMISS_FORCED_ABATEMENT_TRIGGER_SUCCESS,
      DISMISS_FORCED_ABATEMENT_TRIGGER_FAILURE,
    ],
  },
});

export const getCaseHistory = (caseId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/case-history`,
    method: 'get',
    authenticated: true,
    types: [GET_CASE_HISTORY_REQUEST, GET_CASE_HISTORY_SUCCESS, GET_CASE_HISTORY_FAILURE],
  },
});

export const addTimeLog = (caseId: number, addTimeLogRequest: IAddTimeLogRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/time-tracking`,
    method: 'post',
    authenticated: true,
    body: addTimeLogRequest,
    types: [ADD_TIME_LOG_REQUEST, ADD_TIME_LOG_SUCCESS, ADD_TIME_LOG_FAILURE],
  },
});

export const addFine = (caseId: number, addFineRequest: IXerceCaseFineRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/transactions`,
    method: 'post',
    authenticated: true,
    body: addFineRequest,
    types: [ADD_FINE_REQUEST, ADD_FINE_SUCCESS, ADD_FINE_FAILURE],
  },
});

export const updateFineBillToContact = (caseId: number, transactionId: number, billToContactId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/transactions/${transactionId}/bill-to-contact`,
    method: 'put',
    authenticated: true,
    body: { billToContactId },
    types: [
      UPDATE_FINE_BILL_TO_CONTACT_REQUEST,
      UPDATE_FINE_BILL_TO_CONTACT_SUCCESS,
      UPDATE_FINE_BILL_TO_CONTACT_FAILURE,
    ],
  },
});

export const addLateFee = (caseId: number, addLateFeeRequest: IXerceCaseLateFeeRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/late-fee`,
    method: 'post',
    authenticated: true,
    body: addLateFeeRequest,
    types: [ADD_LATE_FEE_REQUEST, ADD_LATE_FEE_SUCCESS, ADD_LATE_FEE_FAILURE],
  },
});

export const addPayment = (caseId: number, addPaymentRequest: IXerceCasePaymentRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/payments`,
    method: 'post',
    authenticated: true,
    body: addPaymentRequest,
    types: [ADD_PAYMENT_REQUEST, ADD_PAYMENT_SUCCESS, ADD_PAYMENT_FAILURE],
  },
});

export const deleteTimeLog = (caseId: number, timeTrackingId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/time-tracking/${timeTrackingId}`,
    method: 'delete',
    authenticated: true,
    types: [DELETE_TIME_LOG_REQUEST, DELETE_TIME_LOG_SUCCESS, DELETE_TIME_LOG_FAILURE],
  },
});

export const getTimeLogHistory = (caseId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/time-tracking`,
    method: 'get',
    authenticated: true,
    types: [GET_TIME_LOG_HISTORY_REQUEST, GET_TIME_LOG_HISTORY_SUCCESS, GET_TIME_LOG_HISTORY_FAILURE],
  },
});

export const getFeeDetails = (caseId: number, params: IPaginationFilters) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/transactions`,
    params,
    method: 'get',
    authenticated: true,
    types: [GET_FINE_PAYEMNT_REQUEST, GET_FINE_PAYEMNT_SUCCESS, GET_FINE_PAYEMNT_FAILURE],
  },
});

export const getScheduledLateFeeDetails = (caseId: number, params: IPaginationFilters) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/scheduledLateFee`,
    params,
    method: 'get',
    authenticated: true,
    types: [GET_SCHEDULED_LATE_FEE_REQUEST, GET_SCHEDULED_LATE_FEE_SUCCESS, GET_SCHEDULED_LATE_FEE_FAILURE],
  },
});

export const setTotalLoggedHours = (totalHours: number) => ({
  type: SET_TOTAL_LOGGED_HOURS,
  payload: totalHours,
});

export const setOutstandingBalance = (amount: string) => ({
  type: SET_OUTSTANDING_BALANCE,
  payload: amount,
});

export const setDueDate = (date: string) => ({
  type: SET_DUE_DATE,
  payload: date,
});

export const getAssociatedCases = (isCCP = false, addressStr = null, apn = null, isDraftLocation = false) => ({
  [CALL_API]: {
    endpoint: 'xerce/locations/associated-cases',
    method: 'get',
    params: {
      addressStr,
      apn,
    },
    authenticated: true,
    types: [
      GET_CASES_COUNT_BY_LOCATION_REQUEST,
      isCCP
        ? GET_CASES_COUNT_BY_LOCATION_CCP_SUCCESS
        : isDraftLocation
        ? GET_CASES_COUNT_BY_DRAFT_LOCATION_SUCCESS
        : GET_CASES_COUNT_BY_LOCATION_SUCCESS,
      GET_CASES_COUNT_BY_LOCATION_FAILURE,
    ],
  },
});

export const voidWaveTransaction = (caseId: number, transactionRequest: any) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/revert-transaction`,
    method: 'post',
    body: transactionRequest,
    authenticated: true,
    types: [VOID_WAIVE_TRANSACTION_REQUEST, VOID_WAIVE_TRANSACTION_SUCCESS, VOID_WAIVE_TRANSACTION_FAILURE],
  },
});

export const linkCase = (payload) => ({
  type: CREATE_AND_LINK_CASE,
  response: payload,
});

export const deleteCaseLink = (linkId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceUnlinkCaseBaseURL}/${linkId}`,
    method: 'delete',
    authenticated: true,
    types: [DELETE_CASE_LINK_REQUEST, DELETE_CASE_LINK_SUCCESS, DELETE_CASE_LINK_FAILURE],
  },
});

export const fetchLocationCustomFieldValues = (
  reqParams: ILocationCustomFieldValuesRequest,
  productType: ConfigProductType = ConfigProductType.XERCE,
  replaceResults: boolean = false
) => {
  const params: ILocationCustomFieldValuesRequest = {
    ...reqParams,
    productType,
  };
  const { offset } = params;

  return {
    [CALL_API]: {
      endpoint: 'xerce/cases/location-custom-field-values',
      params,
      method: 'get',
      authenticated: true,
      types: [
        FETCH_LOCATION_CUSTOM_FIELD_VALUES_REQUEST,
        offset && offset > 0 && !replaceResults
          ? LOAD_MORE_LOCATION_CUSTOM_FIELD_VALUES
          : FETCH_LOCATION_CUSTOM_FIELD_VALUES_SUCCESS,
        FETCH_LOCATION_CUSTOM_FIELD_VALUES_FAILURE,
      ],
      hideLoadingWidget: false,
    },
  };
};

export const fetchLocationCustomFieldValuesCountByIds = (
  configLocationIds: number[],
  productType: ConfigProductType = ConfigProductType.XERCE
) => ({
  [CALL_API]: {
    endpoint: 'xerce/cases/location-custom-field-values-count',
    method: 'post',
    authenticated: true,
    body: {
      configLocationIds,
      productType,
    },
    types: [
      FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_REQUEST,
      FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_SUCCESS,
      FETCH_LOCATION_CUSTOM_FIELD_VALUES_BY_IDS_COUNT_FAILURE,
    ],
    hideLoadingWidget: true,
  },
});

export const generateDocument = (caseId: number, generateRequest: IGenerateFARequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/generate-faa-document`,
    method: 'POST',
    authenticated: true,
    body: generateRequest,
    types: [GENERATE_DOCUMENT_REQUEST, GENERATE_DOCUMENT_SUCCESS, GENERATE_DOCUMENT_FAILURE],
  },
});

export const editDocument = (
  caseId: number,
  forcedAbatementId: number,
  documentId: number,
  note: string,
  documentContent: string[]
) => ({
  [CALL_API]: {
    // tslint:disable-next-line:max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/forced-abatement/${forcedAbatementId}/document/${documentId}`,
    method: 'PUT',
    authenticated: true,
    body: { documentContent, note },
    types: [EDIT_DOCUMENT_REQUEST, EDIT_DOCUMENT_SUCCESS, EDIT_DOCUMENT_FAILURE],
  },
});

export const generateCaseNotice = (generateNoticeRequest: IGenerateNoticeRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/generate-case-notice`,
    method: 'POST',
    authenticated: true,
    body: generateNoticeRequest,
    types: [GENERATE_CASE_NOTICE_REQUEST, GENERATE_CASE_NOTICE_SUCCESS, GENERATE_CASE_NOTICE_FAILURE],
  },
});

export const issueCaseNotice = (caseRequest: IIssueCaseNoticeRequest, caseId: number) => ({
  [CALL_API]: {
    // tslint:disable-next-line: max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/issue-notice`,
    method: 'POST',
    authenticated: true,
    body: caseRequest,
    types: [ISSUE_CASE_NOTICE_REQUEST, ISSUE_CASE_NOTICE_SUCCESS, ISSUE_CASE_NOTICE_FAILURE],
  },
});

export const updateCaseEmailReadStatus = (caseId: number, emails: Array<{ id: number; isRead: boolean }>) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/emails`,
    method: 'put',
    body: emails,
    authenticated: true,
    types: [
      UPDATE_CASE_EMAIL_READ_STATUS_REQUEST,
      UPDATE_CASE_EMAIL_READ_STATUS_SUCCESS,
      UPDATE_CASE_EMAIL_READ_STATUS_FAILURE,
    ],
  },
});

export const sendCEEmail = (caseId: number, email: ICEEmailRequest) => ({
  [CALL_API]: {
    endpoint: `agencies/${xerceCasesBaseURL}/${caseId}/messages`,
    method: 'POST',
    authenticated: true,
    body: email,
    hideLoadingWidget: true,
    types: [SEND_XERCE_EMAIL_REQUEST, SEND_XERCE_EMAIL_SUCCESS, SEND_XERCE_EMAIL_FAILURE],
  },
});

export const getPrivateCEData = (token: string, smsReceiptToken: string = '') => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${token}/private${
      smsReceiptToken.trim().length ? `?smsReceiptToken=${smsReceiptToken}` : ''
    }`,
    method: 'get',
    params: {
      token,
    },
    authenticated: false,
    types: [GET_PRIVATE_CE_DATA_REQUEST, GET_PRIVATE_CE_DATA_SUCCESS, GET_PRIVATE_CE_DATA_FAILURE],
    hideLoadingWidget: false,
  },
});

export const resendMagicLink = (token: string) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${token}/resend-link`,
    method: 'post',
    authenticated: false,
    body: {},
    types: [RESEND_MAGIC_LINK_REQUEST, RESEND_MAGIC_LINK_SUCCESS, RESEND_MAGIC_LINK_FAILURE],
    hideLoadingWidget: false,
  },
});

export const performGroupAction = (groupActionRequest: IXerceGroupActionRequest, params: IGroupActionsParams) => ({
  [CALL_API]: {
    endpoint: `${agenciesXerceBaseURL}/group-actions`,
    method: 'post',
    authenticated: true,
    body: groupActionRequest,
    params,
    types: [GROUP_ACTION_REQUEST, GROUP_ACTION_SUCCESS, GROUP_ACTION_FAILURE],
  },
});

export const stopReoccuringLateFee = (
  caseId: number,
  scheduleLateFeeId: number,
  stopReoccuringLateFeeRequest: IStopReoccuringLateFeeRequest
) => ({
  [CALL_API]: {
    // tslint:disable-next-line:max-line-length
    endpoint: `${xerceCasesBaseURL}/${caseId}/schedule-late-fee-status/${scheduleLateFeeId}`,
    method: 'put',
    authenticated: true,
    body: stopReoccuringLateFeeRequest,
    hideLoadingWidget: true,
    types: [STOP_REOCCURING_LATE_FEE_REQUEST, STOP_REOCCURING_LATE_FEE_SUCCESS, STOP_REOCCURING_LATE_FEE_FAILURE],
  },
});

export const updateCaseCollectionStatus = (caseId: number, statusRequest: ICaseCollectionStatusRequest) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/collections`,
    method: 'post',
    authenticated: true,
    body: statusRequest,
    types: [
      UPDATE_CASE_COLLECTION_STATUS_REQUEST,
      UPDATE_CASE_COLLECTION_STATUS_SUCCESS,
      UPDATE_CASE_COLLECTION_STATUS_FAILURE,
    ],
  },
});

export const getCaseCollectionStatusHistory = (caseId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/collections`,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_CASE_COLLECTION_STATUS_REQUEST,
      FETCH_CASE_COLLECTION_STATUS_SUCCESS,
      FETCH_CASE_COLLECTION_STATUS_FAILURE,
    ],
  },
});

export const addSupervisorNote = (
  caseId: number,
  noticeId: number,
  noticeStatus: AddSupervisorNoticeStatus,
  supervisorNote?: string
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/approve-reject-escalated-notice/${noticeId}`,
    method: 'POST',
    authenticated: true,
    body: {
      noticeStatus,
      ...(supervisorNote && { supervisorNote }),
    },
    types: [ADD_SUPERVISOR_NOTE_REQUEST, ADD_SUPERVISOR_NOTE_SUCCESS, ADD_SUPERVISOR_NOTE_FAILURE],
  },
});

export const getNoticeRecipients = (caseId: number, noticeId: number) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/notices/${noticeId}/recipients`,
    method: 'get',
    authenticated: true,
    types: [GET_NOTICE_RECIPIENTS_REQUEST, GET_NOTICE_RECIPIENTS_SUCCESS, GET_NOTICE_RECIPIENTS_FAILURE],
  },
});

export const editRecipientCMN = (
  caseId: number,
  noticeId: number,
  faaActivityId: number,
  documentId: number,
  recipientCMNs: IRecipientCMN[]
) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/edit-recipient-cmn`,
    method: 'put',
    authenticated: true,
    body: {
      ...(noticeId && { noticeId }),
      ...(faaActivityId && { faaActivityId }),
      ...(documentId && { documentId }),
      recipientCMNs,
    },
    types: [EDIT_RECIPIENT_CMN_REQUEST, EDIT_RECIPIENT_CMN_SUCCESS, EDIT_RECIPIENT_CMN_FAILURE],
  },
});

export const editFAAField = (caseId: number, activityId: number, faaFieldReq: IXerceCaseForcedAbatementFieldReq) => ({
  [CALL_API]: {
    endpoint: `${xerceCasesBaseURL}/${caseId}/forced-abatement/activities/${activityId}/fields`,
    method: 'PUT',
    body: faaFieldReq,
    authenticated: true,
    types: [EDIT_FAA_FIELD_REQUEST, EDIT_FAA_FIELD_SUCCESS, EDIT_FAA_FIELD_FAILURE],
  },
});
